import { getKnightTitle } from "@/services/getKnightTitle";
import { UserType } from "@WahooFitness/cloud-client-types";
import { useMemo } from "react";

const useUserDisplay = (currentUser: UserType | null | undefined) => {
  const knightTitle = useMemo(
    () => (currentUser ? getKnightTitle(currentUser) : null),
    [currentUser]
  );

  const userDisplayName = useMemo(() => {
    if (!currentUser) return null;
    return [knightTitle, currentUser.first ?? "", currentUser.last ?? ""].filter(Boolean).join(" ");
  }, [knightTitle, currentUser]);

  const userInitials = useMemo(() => {
    if (!currentUser) return null;
    return `${currentUser.first?.[0] ?? ""}${currentUser.last?.[0] ?? ""}`;
  }, [currentUser]);

  return { userDisplayName, userInitials };
};

export default useUserDisplay;
